module.exports = __webpack_public_path__ + "img/match-logo-5.0ca5ef00.png";